<nav id="nav-bar" class="navigation" [class.mobile-header]="$isMobile()">
  <button class="button-open" (click)="toggleMenu()">
    <mat-icon [class.open-icon--rotate]="layoutService.hasOpenedMenu()">keyboard_arrow_right</mat-icon>
  </button>
  <div class="logo-wrapper">
    <div class="logo" [class.logo--full]="layoutService.hasOpenedMenu() && !$isMobile()"></div>
    @if (appVersion) {
      <chip type="alert">{{ appVersion }}</chip>
    }
  </div>

  @if (isLogged) {
    @if ($isMobile()) {
      <div style="display: flex; align-items: center; gap: 1rem">
        <button class="action" (click)="openSearchDialog($event)">
          <mat-icon>search</mat-icon>
        </button>
        <button (click)="navigateToNotifications()">
          <mat-icon>notifications_active</mat-icon>
        </button>
        <button class="action" (click)="onOpenNavMobile()">
          <mat-icon>{{ isOpen ? 'close' : 'menu' }}</mat-icon>
        </button>
      </div>
    } @else {
      <ng-container [ngTemplateOutlet]="navigationItems"></ng-container>
    }
  }
</nav>

@if ($isMobile()) {
  <aside
    (touchmove)="touchMoving($event)"
    (touchstart)="touchStart($event)"
    class="mobile-nav"
    [class.mobile-nav--open]="isOpen">
    <ng-container [ngTemplateOutlet]="navigationItems"></ng-container>
  </aside>
}

<ng-template #navigationItems>
  <ul class="items" [class.items--mobile]="$isMobile()">
    @for (item of $navigationItems(); track $index) {
      @if (item.condition) {
        <a
          [id]="'tab-' + item.id"
          [matTooltip]="hasLabel() ? undefined : (item.label | translate)"
          matTooltipPosition="right"
          class="item"
          [routerLink]="item.routerLink"
          [queryParams]="item.queryParams"
          [routerLinkActiveOptions]="MATCH_OPTIONS"
          routerLinkActive="item--active"
          (click)="$isMobile() ? (isOpen = false) : undefined">
          <mat-icon class="item_icon">
            @if (!layoutService.hasOpenedMenu() && !$isMobile()) {
              <ng-container *ngTemplateOutlet="badgesTemplate; context: { $implicit: item }"></ng-container>
            }
            {{ item.icon }}
          </mat-icon>
          @if (hasLabel()) {
            {{ item.label | translate }}

            <ng-container *ngTemplateOutlet="badgesTemplate; context: { $implicit: item }"></ng-container>
          }
        </a>
      }
    }

    <a
      [matTooltip]="hasLabel() ? undefined : ('TAB.RESOURCES' | translate)"
      matTooltipPosition="right"
      class="item item--resources"
      id="demo-tour-step-7"
      routerLink="/resources"
      routerLinkActive="item--active"
      (click)="$isMobile() ? (isOpen = false) : undefined">
      <mat-icon class="item_icon">lightbulb</mat-icon>
      @if (hasLabel()) {
        {{ 'TAB.RESOURCES' | translate }}
      }
    </a>

    @if ($connectedAccount()?.administrator || $connectedAccount()?.supervisor) {
      <button
        [matTooltip]="hasLabel() ? undefined : ('TAB.ADMINISTRATION' | translate)"
        matTooltipPosition="right"
        class="item"
        id="demo-tour-step-5"
        routerLink="/administration"
        routerLinkActive="item--active"
        (click)="$isMobile() ? (isOpen = false) : undefined">
        <mat-icon class="item_icon">settings</mat-icon>
        @if (hasLabel()) {
          {{ 'TAB.ADMINISTRATION' | translate }}
        }
      </button>
    }

    <button
      [matTooltip]="hasLabel() ? undefined : ('TAB.MYACCOUNT' | translate)"
      matTooltipPosition="right"
      class="item item--avatar"
      id="demo-tour-step-6"
      routerLink="/my-account"
      routerLinkActive="item--active"
      (click)="$isMobile() ? (isOpen = false) : undefined">
      <avatar />
      @if (hasLabel() && $fullName()) {
        <p class="avatar_name" [matTooltip]="$fullName()" ubiShowIfTruncated matTooltipPosition="right">
          {{ $fullName() }}
        </p>
      }
    </button>
  </ul>
</ng-template>

<ng-template #badgesTemplate let-item>
  @if (item?.alert) {
    <div style="padding: 3px" aria-hidden="false" [matBadge]="'&#8288;'" matBadgeColor="warn"></div>
  } @else if (item.badge) {
    <div style="padding: 3px" aria-hidden="false" [matBadge]="item.badge" matBadgeColor="warn"></div>
  }
</ng-template>
